import { IMSAggregator } from './aggregator';

/**
 * @ngdoc service
 * @name ims.map.service:BlankAggregator
 * @description
 * The BlankAggregator is a service that returns the inputted value and is used as a
 * empty stand-in for when no aggregator is needed.
 */

export class FirstAggregator extends IMSAggregator {
    /**
     * Takes a list of values, but will always return the FIRST item; or undefined.
     * There's no ordering! It's just the first!
     *
     * TODO This should be replaced with the MostRecentAggregator which uses the timestamp field of stats
     *  to do the ordering and then takes the most recent item; however I was too scared to change the interface
     *  of this class so it only deals with stats, rather than values (which don't have a timestamp property).
     *  The blocker was the coupling between IMSValueGetter and IMSAggregator.
     */
    constructor() {
        super();
        this.logicalName = 'none';
        this.displayName = 'None';
    }

    /**
     * Takes in a value and returns that value.
     * Used for 'aggregating' asset stats for an asset at a time, since there's only ever one
     */
    getAggValueForValueArray(value) {
        // Handle arrays of one or zero things (should be the only situation possible with BlankAggregator)
        if (Array.isArray(value)) {
            return value && value.length > 0 ? value[0] : undefined;
        }
        return value;
    }
}
